class SharedHeaderService {
    constructor() {
        this.data = [];
    }

    set(key, val, store) {
        // also store this in the session store
        store.setItem(key, val);
        this.data[key] = val;
        return val;
    }

    get(key) {
        return this.data[key];
    }

    del(key) {
        delete this.data[key];
    }

    has(key) {
        return (key in this.data);
    }

    reset(){
        this.data = [];
    }

}

export default new SharedHeaderService();